import { EUserLevel } from '../general/types';

export const CONTENT_LIB_SET_SEARCH_FILTER_ACTION = 'CONTENT_LIB/CONTENT_LIB_SET_SEARCH_FILTER_ACTION';
export const CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_EXIST_ACTION = 'CONTENT_LIB/CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_ACTION';
export const CONTENT_LIB_SET_CHANNELS_ACTION = 'CONTENT_LIB/CONTENT_LIB_SET_CHANNELS_ACTION';

export enum EContentLibVideoLevel {
  A1 = 1, A2 = 2, B1 = 3, B2 = 4, C1 = 5, C2 = 6
}

export interface IContentLibSearchFilter {
  targetLangCode: string,
  nativeLangCode: string,
  text: string,
  level: EUserLevel
  channel?: string;
  channelId?: number;
  channelUrl?: string;
}

export interface IContentLibChannel {
  id: number,
  title: string,
  customUrl: string
  avatar?: string;
}

export enum EContentLibViewMode {
  RECORDINGS,
}

export interface IContentLibState {
  channels: IContentLibChannel[];
  searchFilter: IContentLibSearchFilter,
  videosSearchResultExist: boolean,
}

export interface IContentLibSetVideosSearchResultAction {
  type: typeof CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_EXIST_ACTION;
  exist: boolean;
}

export interface IContentLibSetSearchFilterAction {
  type: typeof CONTENT_LIB_SET_SEARCH_FILTER_ACTION;
  searchFilter: Partial<IContentLibSearchFilter>
}

export interface IContentLibSetChannelsAction {
  type: typeof CONTENT_LIB_SET_CHANNELS_ACTION;
  channels: IContentLibChannel[];
}

export type TContentLibActions =
  | IContentLibSetVideosSearchResultAction
  | IContentLibSetSearchFilterAction
  | IContentLibSetChannelsAction
